import { useAppDispatch } from "../../../../../common/state/hooks";
import { notify } from "../../../../../common/state/Slices/NotificationSlice";
import { reset as resetDeviceList } from "../../../../../common/state/Slices/ConnectedDeviceSlice";
import { reset as resetInstalledGadgets } from "../../../../../common/state/Slices/InstalledGadgetsSlice";
import { reset as resetInstalledGadgetsOnAllDevices } from "../../../../../common/state/Slices/InstallOnAllDeviceSlice";

export const useConnectionHandler = () => {
    const dispatch = useAppDispatch();

    const handleOnDisconnect = () => {
        dispatch(
            notify({
                message: "Connection to Garuda is lost",
                severity: "error"
            })
        );
        dispatch(resetDeviceList({}));
        dispatch(resetInstalledGadgets({}));
        dispatch(resetInstalledGadgetsOnAllDevices({}));
    };

    const handleOnConnect = () => {
        dispatch(
            notify({
                message: "Connected to Garuda",
                severity: "success",
                autoHideDuration: 3000
            })
        );
    };

    return {
        handleOnConnect, handleOnDisconnect
    }
}